import CircularProgress from '@mui/material/CircularProgress';
import type { CSSProperties } from 'react';

type Props = {
  color?: string;
  style?: CSSProperties;
  size?: number;
  duration?: number;
};

const Spinner = ({ color, style, size = 28, duration = 1333 }: Props) => {
  return (
    <CircularProgress
      aria-label="Loading"
      color="inherit"
      size={size}
      style={style}
      sx={{
        color,
        verticalAlign: 'middle',
        animationDuration: `${duration}ms`,
        '& .MuiCircularProgress-circle': {
          animationDuration: `${duration}ms`,
        },
      }}
    />
  );
};

export default Spinner;
